import type { CSSProperties, HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

export function StatGrid({ columns, className, style, ...rest }: HTMLAttributes<HTMLDivElement> & { columns?: number }) {
  const s: CSSProperties | undefined = columns ? { gridTemplateColumns: `repeat(${columns}, 1fr)`, ...style } : style;
  return <div className={cx("ax-stat-grid", className)} style={s} {...rest} />;
}

export interface StatTileProps {
  label: ReactNode;
  value: ReactNode;
  size?: "sm";
  /** 方向的好坏由页面按业务判断。 */
  delta?: { text: ReactNode; tone?: "up" | "down" | "warn" };
}

export function StatTile({ label, value, size, delta }: StatTileProps) {
  return (
    <div className="ax-stat">
      <div className="ax-stat-label">{label}</div>
      <div className={cx("ax-stat-value", size === "sm" && "sm")}>{value}</div>
      {delta && <div className={cx("ax-stat-delta", delta.tone)}>{delta.text}</div>}
    </div>
  );
}
